import React, { useState } from 'react'

import Carousel, { Modal, ModalGateway } from 'react-images'
import GalleryItem from './gallery-item'

const Gallery = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  const toggle = index => {
    setCurrentIndex(index)
    setIsOpen(!isOpen)
  }

  return (
    <>
      <div className="gallery">
        {items.map((item, index) => (
          <GalleryItem
            key={item.image.asset._id}
            item={item}
            handleClick={() => toggle(index)}
          />
        ))}
      </div>
      <ModalGateway>
        {isOpen && (
          <Modal onClose={toggle}>
            <Carousel
              currentIndex={currentIndex}
              components={{ View }}
              frameProps={{ autoSize: 'height' }}
              views={items.map(item => ({
                src: item.image.asset.fluid.src,
                handleClick: () => toggle(currentIndex)
              }))}
              styles={{
                view: base => ({
                  ...base,
                  width: 'auto',
                  height: 'calc(100vh - 50px)'
                })
              }}
            />
          </Modal>
        )}
      </ModalGateway>
    </>
  )
}

const View = ({ data }) => (
  <div
    style={{
      position: 'relative',
      width: '100vw',
      height: '100vh'
    }}
    onClick={data.handleClick}
  >
    <img
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'auto',
        height: 'auto',
        maxWidth: '90%',
        maxHeight: '80%'
      }}
      src={data.src}
    />
  </div>
)

export default Gallery
